<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { NicknameColorType } from '@/types/mall'
import { socketEmitAsync } from '@/utils/web-socket'
import { onMounted, ref } from 'vue'

const userStore = useUserStore()

const nicknameColorList = ref<NicknameColorType[]>([])
const curNicknameColor = ref<NicknameColorType>()

async function handleUseNicknameColor() {
  if (!curNicknameColor.value) return
  await socketEmitAsync({ type: 'useNicknameColor', data: { id: curNicknameColor.value.id } })
  userStore.nicknameColor = curNicknameColor.value.color
}

onMounted(async () => {
  const res = await socketEmitAsync<NicknameColorType[]>({ type: 'getPersonNicknameColorCollection' })
  nicknameColorList.value = res
})
</script>

<template>
  <div class="nickname-color">
    <div class="border-wrap" style="margin-bottom: 10px">
      <h4>预览</h4>
      <p style="font-size: 22px; text-align: center">
        <span class="nickname" :style="{ background: curNicknameColor?.color || userStore.nicknameColor }">{{ userStore.nickname }}</span>
      </p>
    </div>
    <div class="nickname-color-list-wrap border-wrap">
      <div class="nickname-color-list">
        <div class="item" v-for="item of nicknameColorList" :key="item.id">
          <el-button size="small" type="primary" plain @click="curNicknameColor = item">
            <span class="nickname" :style="{ background: item.color }">{{ item.name }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px">
      <el-button type="success" plain style="width: 100%" @click="handleUseNicknameColor">穿戴</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.nickname-color {
  .border-wrap {
    padding: 10px;
  }
  .nickname-color-list-wrap {
    margin-bottom: 10px;
    flex: 1;
    .nickname-color-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      .item {
        width: calc(50% - 5px);
        margin-bottom: 10px;
        button {
          width: 100%;
        }
      }
    }
  }
}
</style>
